import axios from "axios";

export const post = async (apiUrl: string, data: any) => {
    try {
      const response = await axios.post(`${apiUrl}`, data);
      return response.data;
    } catch (error) {
      console.error('Error sending POST request:', error);
      throw error;
    }
  };